import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store.js";
import { RouteAccess } from "@/utils/permissions";

Vue.use(Router)

const Placeholder = () => import('@/views/shared/ModulePlaceholder.vue')

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            allowedRoles: RouteAccess.CoreAccess,
            pageTitle: 'Home'
          }
        },
        {
          path: '/user',
          name: 'UserManagement',
          component: () => import('@/views/user/User.vue'),
          meta: {
            allowedRoles: RouteAccess.AdminOnly,
            pageTitle: 'UsersManagement'
          }
        },

        {
          path: '/settings/countries',
          name: 'SettingsCountries',
          component: () => import('@/views/settings/Country/Country.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Countries'
          }
        },
        {
          path: '/settings/nationalities',
          name: 'SettingsNationalities',
          component: () => import('@/views/settings/Nationality/Nationality.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Nationalities'
          }
        },
        {
          path: '/settings/investor-categories',
          name: 'SettingsInvestorCategories',
          component: () => import('@/views/settings/InvestorCategory/InvestorCategory.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Investor Categories'
          }
        },
        {
          path: '/settings/property-types',
          name: 'SettingsPropertyTypes',
          component: () => import('@/views/settings/PropertyType/PropertyType.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Property Types'
          }
        },
        {
          path: '/settings/investor-kyc-statuses',
          name: 'SettingsInvestorKycStatuses',
          component: () => import('@/views/settings/InvestorKycStatus/InvestorKycStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Investor KYC Statuses'
          }
        },
        {
          path: '/settings/wallet-transaction-types',
          name: 'SettingsWalletTransactionTypes',
          component: () => import('@/views/settings/WalletTransactionType/WalletTransactionType.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Wallet Transaction Types'
          }
        },
        {
          path: '/settings/payment-method-types',
          name: 'SettingsPaymentMethodTypes',
          component: () => import('@/views/settings/PaymentMethodType/PaymentMethodType.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Payment Method Types'
          }
        },
        {
          path: '/settings/wallet-statuses',
          name: 'SettingsWalletStatuses',
          component: () => import('@/views/settings/WalletStatus/WalletStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Wallet Statuses'
          }
        },
        {
          path: '/settings/property-listing-statuses',
          name: 'SettingsPropertyListingStatuses',
          component: () => import('@/views/settings/PropertyListingStatus/PropertyListingStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Property Listing Statuses'
          }
        },
        {
          path: '/settings/opportunity-statuses',
          name: 'SettingsOpportunityStatuses',
          component: () => import('@/views/settings/OpportunityStatus/OpportunityStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Opportunity Statuses'
          }
        },
        {
          path: '/settings/token-statuses',
          name: 'SettingsTokenStatuses',
          component: () => import('@/views/settings/TokenStatus/TokenStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Token Statuses'
          }
        },
        {
          path: '/settings/purchase-order-statuses',
          name: 'SettingsPurchaseOrderStatuses',
          component: () => import('@/views/settings/PurchaseOrderStatus/PurchaseOrderStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Purchase Order Statuses'
          }
        },
        {
          path: '/settings/wallet-transaction-statuses',
          name: 'SettingsWalletTransactionStatuses',
          component: () => import('@/views/settings/WalletTransactionStatus/WalletTransactionStatus.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Wallet Transaction Statuses'
          }
        },
        {
          path: '/settings/notification-types',
          name: 'SettingsNotificationTypes',
          component: () => import('@/views/settings/NotificationType/NotificationType.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Notification Types'
          }
        },
        {
          path: '/settings/regions',
          name: 'SettingsRegions',
          component: () => import('@/views/settings/Region/Region.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Regions'
          }
        },
        {
          path: '/settings/cities',
          name: 'SettingsCities',
          component: () => import('@/views/settings/City/City.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Cities'
          }
        },
        {
          path: '/settings/districts',
          name: 'SettingsDistricts',
          component: () => import('@/views/settings/District/District.vue'),
          meta: {
            allowedRoles: RouteAccess.LookupAccess,
            pageTitle: 'Districts'
          }
        },


        // {
        //   path: '/settings/wallet-statuses',
        //   name: 'SettingsWalletStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Wallet Statuses'
        //   }
        // },
        // {
        //   path: '/settings/property-listing-statuses',
        //   name: 'SettingsPropertyListingStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Property Listing Statuses'
        //   }
        // },
        // {
        //   path: '/settings/opportunity-statuses',
        //   name: 'SettingsOpportunityStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Opportunity Statuses'
        //   }
        // },
        // {
        //   path: '/settings/token-statuses',
        //   name: 'SettingsTokenStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Token Statuses'
        //   }
        // },
        // {
        //   path: '/settings/purchase-order-statuses',
        //   name: 'SettingsPurchaseOrderStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Purchase Order Statuses'
        //   }
        // },
        // {
        //   path: '/settings/wallet-transaction-statuses',
        //   name: 'SettingsWalletTransactionStatuses',
        //   component: Placeholder,
        //   meta: {
        //     allowedRoles: RouteAccess.LookupAccess,
        //     pageTitle: 'Wallet Transaction Statuses'
        //   }
        // },

        {
          path: '/Investors',
          name: 'Investors',
          component: () => import('@/views/Investors/Investors.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Investors', active: true },
            ],
            pageTitle: 'Investors',
            rule: 'anonymous'
          },
        },
        {
          path: "/Investors/AddOrEditInvestor/:ID?",
          name: "Add Or Edit Investor",
          component: () => import("@/views/Investors/AddOrEditInvestors.vue"),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: "AddOr Edit Investor", active: true }
            ],
            rule: "anonymous",
            pageTitle: "AddOrEditInvestor"
          }
        },
{
          path: '/PropertyOwners',
          name: 'PropertyOwners',
          component: () => import('@/views/PropertyOwners/PropertyOwnersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Property Owners', active: true },
            ],
            pageTitle: 'Property Owners',
            rule: 'anonymous'
          },
        },
        {
          path: "/PropertyOwners/AddOrEditOwner/:ID?",
          name: "Add Or Edit Property Owner",
          component: () => import("@/views/PropertyOwners/PropertyOwnerEdit.vue"),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: "Add Or Edit Property Owner", active: true }
            ],
            rule: "anonymous",
            pageTitle: "AddOrEditPropertyOwner"
          }
        },
        {
          path: '/Properties',
          name: 'Properties',
          component: () => import('@/views/Properties/Properties.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Properties', active: true },
            ],
            pageTitle: 'Properties',
            rule: 'anonymous'
          },
        },
        {
          path: "/Properties/AddOrEditProperties/:ID?",
          name: "Add Or Edit Properties",
          component: () => import("@/views/Properties/AddOrEditProperties.vue"),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: "AddOr Edit Properties", active: true }
            ],
            rule: "anonymous",
            pageTitle: "AddOrEditProperties"
          }
        },

        {
          path: '/Opportunities',
          name: 'Opportunities',
          component: () => import('@/views/Opportunities/Opportunities.vue'),
          meta: {
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
            {
              title: 'Opportunities',
              active: true
            },
            ],
            pageTitle: 'Opportunities',
            rule: 'anonymous'
          },
        },
        {
          path: "/Opportunities/AddOrEditOpportunities/:ID?",
          name: "Add Or Edit Opportunities",
          component: () => import("./views/Opportunities/AddOrEditOpportunities.vue"),
          meta: {
            breadcrumb: [
              { title: "", url: "/Opportunities/AddOrEditOpportunities", active: true },
              { title: "Add Or Edit Opportunities", active: true }
            ],
            rule: "anonymous",
            pageTitle: "AddOrEditOpportunities"
          }
        },

        {
          path: '/Tokens',
          name: 'Tokens',
          component: () => import('@/views/Tokens/Tokens.vue'),
          meta: {
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
            {
              title: 'Tokens',
              active: true
            },
            ],
            pageTitle: 'Tokens',
            rule: 'anonymous'
          },
        },
        {
          path: '/PurchaseOrders',
          name: 'PurchaseOrders',
          component: () => import('@/views/PurchaseOrders/PurchaseOrders.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Purchase Orders', active: true },
            ],
            pageTitle: 'PurchaseOrders',
            rule: 'anonymous'
          },
        },
        {
          path: '/ComplaintSuggestions',
          name: 'ComplaintSuggestions',
          component: () => import('@/views/ComplaintSuggestions/ComplaintSuggestions.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Complaint Suggestions', active: true },
            ],
            pageTitle: 'ComplaintSuggestions',
            rule: 'anonymous'
          },
        },
        {
          path: "/ComplaintSuggestions/ViewComplaintSuggestions/:ID?",
          name: "View Complaint Suggestions",
          component: () => import("./views/ComplaintSuggestions/ViewComplaintSuggestions.vue"),
          meta: {
            breadcrumb: [
              { title: "", url: "/ComplaintSuggestions/ViewComplaintSuggestions", active: true },
              { title: "View Complaint Suggestions", active: true }
            ],
            rule: "anonymous",
            pageTitle: "ViewComplaintSuggestions"
          }
        },
        {
          path: '/Reports',
          name: 'Reports',
          component: () =>
            import('@/views/Reports/Reports.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },

              { title: 'RecordsReports', active: true },
            ],
            rule: 'editor',
            pageTitle: "RecordsReports",
          }
        },

        {
          path: '/pages/profile',
          name: 'page-profile',
          component: () => import('@/views/pages/Profile.vue'),
          meta: {
            allowedRoles: RouteAccess.CoreAccess,
            pageTitle: 'Profile'
          }
        },
        {
          path: '/changePassword',
          name: 'ChangePassword',
          component: () => import('@/views/changePassword.vue'),
          meta: {
            allowedRoles: RouteAccess.CoreAccess,
            pageTitle: 'Change Password'
          }
        }
      ]

    },
    //Report Route should be outside the main layout because it needs to open in a new tab without the main layout
    {

      path: '/Reports/InvestorReport/:InvestorID?',
      name: 'investor-report-viewer',
      component: () => import('@/views/Reports/InvestorReport.vue')
    },
    {

      path: '/Reports/InvestorOpportunities/:InvestorID?',
      name: 'InvestorOpportunities',
      component: () => import('@/views/Reports/InvestorOpportunities.vue')
    },
    // Full Page Layout Routes (e.g., Login, Error Pages)
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/pages/login/:IncomeCode?',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: { pageTitle: 'Login' }
        },
        {
          path: '/registration/registerType',
          name: 'registerType',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: { pageTitle: 'Register' }
        },
        {
          path: '/pages/ForgotPassword',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: { pageTitle: 'Forgot Password' }
        },
        {
          path: '/pages/CheckCode/:Email?',
          name: 'CheckCode',
          component: () => import('@/views/pages/CheckCode.vue'),
          meta: { pageTitle: 'Check Code' }
        },
        {
          path: '/pages/ResetPassword',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: { pageTitle: 'Reset Password' }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue')
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue')
        }
      ]
    }
  ]
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/pages/login",
    "/pages/ForgotPassword",
    "/pages/ResetPassword",
    "/registration/registerType"
  ];

  const isPublic = publicPages.indexOf(to.path) !== -1;
  const loggedIn = store.state.auth.isUserLoggedIn();

  if (!isPublic && !loggedIn) {
    next("/pages/login");
    return;
  }

  if (to.path === "/pages/login" && loggedIn) {
    next("/");
    return;
  }

  // if (to.path.startsWith("/pages/login") && loggedIn) {
  //   next({ path: "/" });
  //   return;
  // }

  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userRole = userInfo.userType || userInfo.UserType || "";
  const allowedRoles = to.meta && to.meta.allowedRoles ? to.meta.allowedRoles : null;

  if (allowedRoles && allowedRoles.indexOf(userRole) === -1) {
    next("/pages/not-authorized");
    return;
  }

  next();
});

export default router
